import type { FlowEdge, FlowNode } from '../types/flow-types';

export interface FlowSelectionClipboard {
	nodes: FlowNode[];
	edges: FlowEdge[];
}

const STORAGE_KEY = 'shelly.flow-selection-clipboard.v1';
let memoryClipboard: FlowSelectionClipboard | null = null;

function clone(value: FlowSelectionClipboard): FlowSelectionClipboard {
	return typeof structuredClone === 'function'
		? structuredClone(value)
		: JSON.parse(JSON.stringify(value));
}

export function writeFlowSelectionClipboard(
	value: FlowSelectionClipboard,
	storage: Storage | undefined = typeof sessionStorage !== 'undefined' ? sessionStorage : undefined,
): void {
	memoryClipboard = clone(value);
	try {
		storage?.setItem(STORAGE_KEY, JSON.stringify(value));
	} catch {
		// Module memory still supports navigation while storage is unavailable.
	}
}

export function readFlowSelectionClipboard(
	storage: Storage | undefined = typeof sessionStorage !== 'undefined' ? sessionStorage : undefined,
): FlowSelectionClipboard | null {
	if (memoryClipboard) return clone(memoryClipboard);
	try {
		const parsed = JSON.parse(storage?.getItem(STORAGE_KEY) || 'null');
		if (!parsed || !Array.isArray(parsed.nodes) || !Array.isArray(parsed.edges)) return null;
		memoryClipboard = parsed;
		return clone(parsed);
	} catch {
		return null;
	}
}

export function clearFlowSelectionClipboard(
	storage: Storage | undefined = typeof sessionStorage !== 'undefined' ? sessionStorage : undefined,
): void {
	memoryClipboard = null;
	try {
		storage?.removeItem(STORAGE_KEY);
	} catch {
		// Nothing else to clear.
	}
}
